module.exports = __webpack_public_path__ + "img/02.e20f38b0.jpg";